import FavoriteProductView from 'chairisher/view/product/favorite';
import ReferrerUtils from 'chairisher/util/referrer';

import { getAmplitudeEventPropertiesForProduct } from 'chairisher/analytics/product';
import {
    getAreMessagesEnabled,
    getNumProductReviews,
    getProductRating,
    getProductSellerType,
    isSampleAvailable,
} from 'chairisher/context/product';
import { getNumSellerReviews, getSellerRating } from 'chairisher/context/sellerreviews';
import { AmplitudeEventProperty, logAmplitudeEvent, TrackingScreen } from 'chairisher/util/analytics';

/**
 * Tracks the display of the product detail page
 *
 * @param {ProductModel} product The product being displayed in the PDP
 */
export function trackProductDetailPageview(product) {
    const amplitudeEventProperties = {
        ...getAmplitudeEventPropertiesForProduct(product),
        [AmplitudeEventProperty.ARE_MESSAGES_ENABLED]: getAreMessagesEnabled(),
        [AmplitudeEventProperty.IS_FAVORITED_BY_VIEWER]: FavoriteProductView.isProductIdFavorited(product.getId()),
        [AmplitudeEventProperty.IS_MULTIPLE]: product.getIsMultiple(),
        [AmplitudeEventProperty.IS_SAMPLE_AVAILABLE]: isSampleAvailable(),
        [AmplitudeEventProperty.NUM_PRODUCT_REVIEWS]: getNumProductReviews(),
        [AmplitudeEventProperty.NUM_SELLER_REVIEWS]: getNumSellerReviews(),
        [AmplitudeEventProperty.PRODUCT_RATING]: getProductRating(),
        [AmplitudeEventProperty.PRODUCT_STATE_DISPLAY]: product.getProductStateDisplay(),
        [AmplitudeEventProperty.PRODUCT_SELLER_TYPE]: getProductSellerType(),
        [AmplitudeEventProperty.SELLER_RATING]: getSellerRating(),
    };

    const [referreringCollection] =
        ReferrerUtils.getReferrer().match(/\/(city|collection|maker|room|style)\/[a-zA-Z0-9-]+/) ?? [];
    if (referreringCollection) {
        amplitudeEventProperties[AmplitudeEventProperty.REFERRING_COLLECTION] = referreringCollection;
    }

    logAmplitudeEvent('screen - product detail', amplitudeEventProperties);
}

/**
 * Tracks a product's shipping information
 *
 * @param {ProductModel} product The product that is being viewed
 * @param {number} preAdjustedPrice CHAIR-17547 temp param for the pre adjustment shipping price
 */
export function trackProductShippingChanged(product, preAdjustedPrice) {
    const amplitudeEventProperties = {
        [AmplitudeEventProperty.SHIPPING_COST]: product.getShippingCost(),
        [AmplitudeEventProperty.SHIPPING_PARTNER_CODE]: product.getShippingPartnerCode(),
        [AmplitudeEventProperty.SCREEN]: TrackingScreen.PDP,
        // TODO (CHAIR-17547) remove when test is done
        [AmplitudeEventProperty.SHIPPING_ENGINE_COST]: preAdjustedPrice,
    };

    const shippingDistance = product.getShippingDistance();
    if (shippingDistance !== undefined) {
        amplitudeEventProperties[AmplitudeEventProperty.SHIPPING_DISTANCE] = shippingDistance;
    }

    logAmplitudeEvent('product - shipping change', amplitudeEventProperties);
}

/**
 * Tracks the display of the sample modal from the product detail page
 *
 * @param {ProductModel} product The product that is being viewed
 * @param {string} displayType The type of display to track; e.g. 'open' and 'close'
 */
export function trackSampleModalDisplay(product, displayType) {
    const amplitudeEventProperties = getAmplitudeEventPropertiesForProduct(product);
    logAmplitudeEvent(`sample modal - ${displayType}`, amplitudeEventProperties);
}
